import {
  CardMenu,
  CardMenuProps,
} from "@/components/Dashboard/components/Card/Card.Menu";
import { CardTechSALabel, CardTechSALabelProps } from "./Card.TechSALabel";
import {
  DEFAULT_SHOW_ADDITIONAL_CARD_TECHNICIANS,
  DEFAULT_SHOW_CARD_TECHNICIAN,
} from "@/lib/const";

export interface CardSidebarProps extends CardMenuProps, CardTechSALabelProps {}

export const CardSidebar = ({
  cardData,
  employees,
  disabled,
  shop,
  onMoveToClick,
  onMenuOpenChange,
}: CardSidebarProps) => {
  return (
    <div className="absolute -top-0.5 right-0.5 flex flex-col items-end justify-start gap-0.5">
      <CardTechSALabel
        cardData={cardData}
        employees={employees}
        showTechnician={
          shop?.shopConfig?.showCardTechnician ?? DEFAULT_SHOW_CARD_TECHNICIAN
        }
        showAdditionalTechnicians={
          shop?.shopConfig?.showAdditionalCardTechnicians ??
          DEFAULT_SHOW_ADDITIONAL_CARD_TECHNICIANS
        }
      />
      <CardMenu
        cardData={cardData}
        disabled={disabled}
        shop={shop}
        employees={employees}
        onMoveToClick={onMoveToClick}
        onMenuOpenChange={onMenuOpenChange}
      />
    </div>
  );
};
